import { connect } from 'react-redux';
import ChatScreen from 'views/chatScreen/ChatScreen';

export default connect(null, null)(ChatScreen);
